module.exports = __webpack_public_path__ + "img/1.d9e0ee0a.png";